import { render, staticRenderFns } from "./pay_diamond.vue?vue&type=template&id=21e5ee20&scoped=true&"
import script from "./pay_diamond.vue?vue&type=script&lang=js&"
export * from "./pay_diamond.vue?vue&type=script&lang=js&"
import style0 from "./pay_diamond.vue?vue&type=style&index=0&id=21e5ee20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e5ee20",
  null
  
)

export default component.exports